import { render, staticRenderFns } from "./recordingDetails.vue?vue&type=template&id=0c4dd71e&scoped=true&"
import script from "./recordingDetails.vue?vue&type=script&lang=js&"
export * from "./recordingDetails.vue?vue&type=script&lang=js&"
import style0 from "./recordingDetails.vue?vue&type=style&index=0&id=0c4dd71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4dd71e",
  null
  
)

export default component.exports